export const defaultInputValidationPaneSendButtonHoveredStyles = {};